import {Api} from "../api/Api";
import {useErrorWebhook} from "./useErrorWebhook";

export const useFollowupSignTimeUpdates = () => {
    const { ErrorWebhookTrigger } = useErrorWebhook();

    const saveFollowupUserSignUpdates = async (message_type,uuid,followup_data,pageName) => {
        const responseSign = await Api.post("/api/v1/data-ingestion-pipeline", {
            message_type,
            uuid,
            followup_data,
            pageName
        }).catch(function (error) {
            const erroMessage = {
                serviceName : 'Data Ingestion : '+message_type,
                errorReason:error.message,
                errorCode:error.code,
            }
                ErrorWebhookTrigger(erroMessage);
            })
        return responseSign;
    }
    return { 
       
        saveFollowupUserSignUpdates
    }
}